import LowInventoryItemBar from './LowInventoryItemBar';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

function LowInventoryItems() {
    const location = useLocation();

    const productsInsights = useSelector((state) => state.reportAnalysis.productsInsights.productsInsights);

    return (
        <div  className="border border-[#EAEAEA] rounded-lg w-1/2 aspect-video pt-4 pb-2 flex flex-col">
            <div className="flex items-center justify-between px-4">
                <h1 className="text-[#121212] font-semibold text-base">Low Inventory Products</h1>

                <Link className="text-[#1055EB] font-semibold text-[12px] leading-6" to={`${location.pathname}/low-inventory-products`}>View all</Link>
            </div>

            <div className="flex flex-col mt-3">
                <div className="flex items-center text-[14px] leading-6 text-[#666666] font-semibold">
                    <h2 className="w-[78%] pl-4 pr-[10px] py-2 bg-[#F5F5F5] uppercase">products</h2>
                    <h2 className="w-[22%] pl-4 pr-[10px] py-2 bg-[#F5F5F5]">In Stock</h2>
                </div>

                {
                    Object.keys(productsInsights).length > 0 && 
                    productsInsights.lowInventoryProducts.length > 0 && 
                    productsInsights.lowInventoryProducts.slice(0, 5).map(product => {
                        return (
                            <LowInventoryItemBar 
                                key={product.id} 
                                product={product} 
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default LowInventoryItems;
